var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("403 Forbidden")]),_c('h2',[_vm._v("У вас не хватает прав для доступа к этой странице.")])])}]

export { render, staticRenderFns }